import { filterMedia } from "./mediaContext"
import { getAccessToken } from "../../services/authService"

// AI Video requests. The server holds the OpenRouter key, picks the model and records cost.
const call = async (path, init = {}) => {
  const token = getAccessToken()
  if (!token) throw new Error("Please sign in again.")
  const response = await fetch(`${process.env.REACT_APP_DEV_API}${path}`, { ...init, headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}`, ...(init.headers || {}) } })
  const data = await response.json().catch(() => ({}))
  if (!response.ok) throw new Error(data.message || "Something went wrong. Please try again.")
  return data
}
const newRequestId = () => (window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2, 12)}`)

export const getVideoAccess = () => call("/ai/video/access")
export const listVideoFrames = (scriptId, sceneId) => call(`/ai/video/frames?scriptId=${encodeURIComponent(scriptId)}${sceneId ? `&sceneId=${encodeURIComponent(sceneId)}` : ""}`).then((d) => d.frames || [])
// requestId makes a repeated click or network replay return the same job instead of starting another.
export const startVideo = (request) => call("/ai/video", { method: "POST", body: JSON.stringify({ ...request, requestId: request.requestId || newRequestId() }) }).then((d) => d.video)
export const listVideos = (scriptId) => call(`/ai/videos${scriptId ? `?scriptId=${encodeURIComponent(scriptId)}` : ""}`).then((d) => filterMedia(d.videos || [], scriptId))
export const getVideo = (id) => call(`/ai/video/${id}`).then((d) => d.video)
export const deleteVideo = (id) => call(`/ai/video/${id}`, { method: "DELETE" })
export { newRequestId }
